import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      margin: '2px',
      display: 'block',
      cursor: 'pointer'
    }
  },
  unit: {
    margin: '2px',
    height: '24px',
    fontSize: '15px',
    padding: '0 6px',
    display: 'block',
    fontWeight: '700',
    lineHeight: '24px',
    borderRadius: '2px'
  }
});
export default useStyles;